<template>
    <div>
        <ComponentHeader />
        <main>
            <HeroComponent title="Portfolio" img="portafilo_hero_img.png" position="25" pageClass="portafilo" />
            <section class="PortafiloSection">
                <div class="PortafiloWrapper container">
                    <div class="PortafiloBody">
                        <div v-for="item in images" :key="item.img">
                            <div class="wrapper">
                                <v-img :src="item.img" :lazy-src="item.img" aspect-ratio="1" class="grey lighten-2">
                                    <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0 LoaderImages" align="center" justify="center">
                                            <v-progress-circular indeterminate color="grey lighten-5 ">
                                            </v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                                <div class="title"><strong>{{item.title}}</strong></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <FooterCompinent />
    </div>
</template>

<script>
    import ComponentHeader from "@/components/Header.vue";
    import FooterCompinent from "@/components/Footer.vue";
    import HeroComponent from "@/components/HeroComonent.vue"

    export default {
        name: "PortafiloView",
        components: {
            ComponentHeader,
            FooterCompinent,
            HeroComponent
        },
        data() {
            return {
                loading: false,
                images: [{
                        img: "https://picsum.photos/id/22/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/83/200/300",
                        title: "Business Process Automation"
                    }, {
                        img: "https://picsum.photos/id/46/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/65/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/69/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/77/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/23/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/59/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/130/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/115/200/300",
                        title: "Business Process Automation"
                    }, {
                        img: "https://picsum.photos/id/172/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/133/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/147/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/155/200/300",
                        title: "Business Process Automation"
                    },
                    {
                        img: "https://picsum.photos/id/185/200/300",
                        title: "Business Process Automation"
                    }
                ]
            }
        },
        methods: {
            removeLoader() {
                this.loading = true
            }
        },
        mounted() {
            setTimeout(this.removeLoader, 5000)
        },
    }
</script>

<style scoped lang="scss">
    .LoaderImages {
        margin-top: 40% !important;
        margin-left: 45% !important;
    }

    .PortafiloSection {
        .PortafiloWrapper {
            .PortafiloBody {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                padding-top: 87px;
                margin-left: 22px;

                div {
                    width: 448px;
                    height: 435px;
                    margin-right: 12px;
                    margin-bottom: 12px;

                    .wrapper {
                        position: relative;

                  

                        .title {
                            display: none;
                            animation: imagesContent 1s;
                            position: absolute;
                            top: -0px;
                            background-color: rgba(0, 0, 0, 0.8);
                            z-index: 8;
                            width: 100%;
                            height: 100%;
                            margin-left: 0px;
                            text-align: center;

                            strong {
                                display: block;
                                color: #fff;
                                margin-top: 45%;
                                font-size: 20px;
                            }
                        }
                    }

                    .wrapper:hover {
                        .title {
                            display: block;
                        }
                    }
                }

            }
        }
    }

    @keyframes imagesContent {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @media only screen and (max-width: 1900px) {
        .PortafiloSection {
            .PortafiloWrapper {
                .PortafiloBody {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    padding-top: 87px;
                    margin-left: 22px;

                    div {
                        width: 350px;
                        height: 350px;
                        margin-right: 12px;
                        margin-bottom: 12px;

                        .wrapper {
                            position: relative;

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            .title {
                                display: none;
                                animation: imagesContent 1s;
                                position: absolute;
                                top: 0px;
                                background-color: rgba(0, 0, 0, 0.8);
                                z-index: 8;
                                width: 350px;
                                height: 350px;
                                margin-left: 0px;
                                text-align: center;

                                strong {
                                    display: block;
                                    color: #fff;
                                    margin-top: 45%;
                                    font-size: 20px;
                                }
                            }
                        }

                        .wrapper:hover .title {
                            display: block;
                        }
                    }

                }
            }
        }
    }

    @media only screen and (max-width: 720px) {
        .PortafiloSection {
            .PortafiloWrapper {
                .PortafiloBody {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    padding: 0;

                    div {
                        width: 300px;
                        height: 300px;
                        margin: 0;
                        margin-top: 10px;
                        margin-right: 10px;

                        .wrapper {
                            position: relative;

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            .title {
                                display: none;
                                animation: imagesContent 1s;
                                position: absolute;
                                top: -9px;
                                background-color: rgba(0, 0, 0, 0.8);
                                z-index: 8;
                                width: 300px;
                                height: 300px;
                                margin-left: 0px;
                                text-align: center;

                                strong {
                                    display: block;
                                    color: #fff;
                                    margin-top: 45%;
                                    font-size: 20px;
                                }
                            }
                        }

                        .wrapper:hover .title {
                            display: block;
                        }
                    }

                }
            }
        }

    }

    @media only screen and (max-width: 430px) {
        .PortafiloSection {
            .PortafiloWrapper {
                .PortafiloBody {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    padding: 0;
                    margin: 0;
                    div {
                        width: 150px;
                        height: 150px;
                        margin: 0px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .wrapper {
                            position: relative;

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            .title {
                                display: none;
                                animation: imagesContent 1s;
                                position: absolute;
                                top: 0px;
                                background-color: rgba(0, 0, 0, 0.8);
                                z-index: 8;
                                width: 100%;
                                height: 100%;
                                margin-left: 0px;
                                text-align: center;

                                strong {
                                    display: block;
                                    color: #fff;
                                    margin-top: 45%;
                                    font-size: 12px;
                                }
                            }
                        }

                        .wrapper:hover .title {
                            display: block;
                        }
                    }

                }
            }
        }

    }
</style>